module.exports = {"id":"chinese","title":"Krump","author":"Chinese Krump","style":"krump","language":"zh","thumbnail":"https://i.ytimg.com/vi/cQeyWYo0VuQ/mqdefault.jpg","sections":[{"title":"Tutorial","videos":[{"youtubeId":"cQeyWYo0VuQ","duration":"PT8M50S","title":"Tutorial","height":344,"width":459}]}]}


//////////////////
// WEBPACK FOOTER
// ../common/js/tutorials/playlists/krump/chinese.json
// module id = LLsO
// module chunks = 0 1